var render = function render(){var _vm=this,_c=_vm._self._c;return _c('f7-card',{staticClass:"elevation-3 m-t-30"},[_c('f7-card-header',{staticClass:"bg-madai text-white bold p-l-10 m-b-0"},[_vm._v("Anillo Mario Bros.")]),_c('f7-card-content',{staticStyle:{"padding":"10px","border-bottom":"2px solid #293061"}},[_c('f7-photo-browser',{ref:"edgar",attrs:{"navbar-of-text":"de","photos":[
        {
          caption: 'Sketch',
          url: '//movil.madai.mx/360/mario_bros/sketch1.jpg'
        },
        {
          caption: 'Sketch',
          url: '//movil.madai.mx/360/mario_bros/sketch2.jpg'
        },
        {
          caption: 'Sketch',
          url: '//movil.madai.mx/360/mario_bros/sketch3.jpg'
        },
        {
          caption: 'Sketch',
          url: '//movil.madai.mx/360/mario_bros/sketch4.jpg'
        },
        {
          caption: 'Modelo 3D',
          url: '//movil.madai.mx/360/mario_bros/modelo3d1.jpg'
        },
        {
          caption: 'Modelo 3D',
          url: '//movil.madai.mx/360/mario_bros/modelo3d2.jpg'
        },
        {
          caption: 'Modelo 3D',
          url: '//movil.madai.mx/360/mario_bros/modelo3d3.jpg'
        },
        {
          caption: 'Modelo 3D',
          url: '//movil.madai.mx/360/mario_bros/modelo3d4.jpg'
        },
        {
          caption: 'Modelo 3D',
          url: '//movil.madai.mx/360/mario_bros/modelo3d5.jpg'
        },
        {
          caption: 'Render',
          url: '//movil.madai.mx/360/mario_bros/render1.jpg'
        },
        {
          caption: 'Render',
          url: '//movil.madai.mx/360/mario_bros/render2.jpg'
        },
        {
          caption: 'Render',
          url: '//movil.madai.mx/360/mario_bros/render3.jpg'
        },
        {
          caption: 'Render',
          url: '//movil.madai.mx/360/mario_bros/render4.jpg'
        },
        {
          caption: 'Resina',
          url: '//movil.madai.mx/360/mario_bros/resina1.jpg'
        },
        {
          caption: 'Vaciado',
          url: '//movil.madai.mx/360/mario_bros/vaciado1.jpg'
        },
        {
          caption: 'Vaciado',
          url: '//movil.madai.mx/360/mario_bros/vaciado2.jpg'
        }
      ],"type":"popup","theme":"dark"}}),_c('f7-row',[_c('f7-col',[_c('div',{staticClass:"embed"},[_c('iframe',{staticClass:"border-0",attrs:{"src":"//movil.madai.mx/360/mario_bros/360_2/index.html","scrolling":"no","height":"200"}})])])],1)],1),_c('f7-card-footer',{staticStyle:{"background-color":"rgba(158, 158, 158, 0.13)"}},[_c('div',{staticClass:"wd-100"},[_c('f7-block',{staticClass:"m-t-10 p-0"},[_c('span',{staticClass:"text-madai bold m-b-0 fs-16"},[_vm._v("Etapas del proyecto")]),_c('hr')]),_c('f7-swiper',{ref:"swiper",staticClass:"m-t-20 p-b-40",attrs:{"pagination":"","params":{speed:500, slidesPerView: 4}}},[_c('f7-swiper-slide',{staticClass:"text-center"},[_c('img',{staticStyle:{"border":"3px solid #293061","border-radius":"50%","width":"60px","height":"60px"},attrs:{"src":"//movil.madai.mx/360/mario_bros/sketch1.jpg","alt":""},on:{"click":function($event){return _vm.$refs.edgar.open(0)}}}),_c('div',{staticClass:"text-center bold text-black text-uppercase fs-14"},[_vm._v("sketch")])]),_c('f7-swiper-slide',{staticClass:"text-center"},[_c('img',{staticStyle:{"border":"3px solid #293061","border-radius":"50%","width":"60px","height":"60px"},attrs:{"src":"//movil.madai.mx/360/mario_bros/modelo3d1.jpg","alt":""},on:{"click":function($event){return _vm.$refs.edgar.open(4)}}}),_c('div',{staticClass:"text-center bold text-black text-uppercase fs-14"},[_vm._v("modelo 3d")])]),_c('f7-swiper-slide',{staticClass:"text-center"},[_c('img',{staticStyle:{"border":"3px solid #293061","border-radius":"50%","width":"60px","height":"60px"},attrs:{"src":"//movil.madai.mx/360/mario_bros/render3.jpg","alt":""},on:{"click":function($event){return _vm.$refs.edgar.open(9)}}}),_c('div',{staticClass:"text-center bold text-black text-uppercase fs-14"},[_vm._v("render")])]),_c('f7-swiper-slide',{staticClass:"text-center"},[_c('img',{staticStyle:{"border":"3px solid #293061","border-radius":"50%","width":"60px","height":"60px"},attrs:{"src":"//movil.madai.mx/360/mario_bros/resina1.jpg","alt":""},on:{"click":function($event){return _vm.$refs.edgar.open(13)}}}),_c('div',{staticClass:"text-center bold text-black text-uppercase fs-14"},[_vm._v("resina")])]),_c('f7-swiper-slide',{staticClass:"text-center"},[_c('img',{staticStyle:{"border":"3px solid #293061","border-radius":"50%","width":"60px","height":"60px"},attrs:{"src":"//movil.madai.mx/360/mario_bros/vaciado1.jpg","alt":""},on:{"click":function($event){return _vm.$refs.edgar.open(14)}}}),_c('div',{staticClass:"text-center bold text-black text-uppercase fs-14"},[_vm._v("vaciado")])])],1)],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }